import React, {Component} from 'react';
import {Col, Row} from "react-bootstrap";
import logoimg from "../img/square.png";
import CheckAdmin from "./checkAdmin";
import Nav from "react-bootstrap/Nav";
import {Link} from "react-router-dom";

class Footer extends Component {
    render() {
        const currentYear = new Date().getFullYear();
        return (
            <footer className="py-5 mt-5 text-center border-top">
                <div className="px-5">
                    <img src={logoimg} style={{maxHeight: "60px"}} className="img-fluid"/>
                    <Row>
                        <Col xs={12} md={6}>
                            World by Mau &copy; {currentYear}
                        </Col>
                        <Col xs={12} md={6}>
                            Created by Lexikonn.eu
                        </Col>
                    </Row>
                    <div className="mt-5">Děkujeme, že respektujete práci autora. Všechny texty na této stránce jsou chráněny autorským právem.</div>

                    {(CheckAdmin() ? (
                        <div className="lead mt-5">
                            <i className="bi bi-activity"></i> Vytvořeno pro moji skvělou Vanillku
                        </div>
                    ) : null)}
                </div>
            </footer>
        );
    }
}

export default Footer;